




















































































































































































































































































import Vue from "vue";
import { $eventsBus } from "@/main";
import BaseInput from "@/app/shared/components/base/BaseInput.vue";
import BaseButton from "@/app/shared/components/base/BaseButton.vue";
import BaseSimpleSlider from "@/app/shared/components/base/BaseSimpleSlider.vue";
import Dropzone from "@/app/modules/work/components/left-panel/TheLeftPanelDropzone.vue";
import { ResizeObserver } from "vue-resize";
import { Item } from "../../classes/Item";
import vueCustomScrollbar from "vue-custom-scrollbar";
import { TimeHelper } from "../../classes/helpers/TimeHelper";

export default Vue.extend({
  name: "LeftPanel",
  components: {
    BaseInput,
    BaseButton,
    BaseSimpleSlider,
    Dropzone,
    ResizeObserver,
    vueCustomScrollbar,
  },
  data: function () {
    return {
      isDragOver: false,
      itemsBlockHeight: 0,
      showAspectRatioWarning: false,
    };
  },
  computed: {
    items: function () {
      return this.$store.state.items;
    },
    previewItem: function () {
      return this.$store.state.selectedItem;
    },
    filesToUpload: function () {
      return this.$store.state.filesToUpload;
    },
    isMixerStep: {
      get: function () {
        return this.$store.state.isMixerStep;
      },
      set: function (isMixerStep) {
        this.$store.commit("isMixerStep", isMixerStep);
      },
    },
    keymap: function () {
      return {};
    },
  },
  created() {
    $eventsBus.$on("itemsExported", () => {
      this.isExporting = false;
    });
    setInterval(() => {
      this.checkAutocuttingIsReady();
    }, 1000);
  },
  mounted() {
    this.itemsBlockHeight = this.$refs.items
      ? this.$refs.items.getBoundingClientRect().height
      : 0;
  },
  destroyed() {},
  watch: {},
  methods: {
    onResize() {
      this.itemsBlockHeight = this.$refs.items
        ? this.$refs.items.getBoundingClientRect().height
        : 0;
    },
    onDeleteItem(item) {
      this.$store.commit("deleteItem", item);
      //this.deletedObjects.push([item]);
      this.$store.commit("addNewStateToHistory");
      $eventsBus.$emit("saveUserWorkspace");
    },
    onAutocut(item) {
      if (!item.autocutParameters.isReadyToAutocut || this.isMixerStep) {
        return;
      }
      $eventsBus.$emit("openTabInRightPanel", "Parts");
      this.axios
        .post(
          "/v2.0/autocut/getFramesInfo",
          {
            fileId: item.fileId,
            params: {
              partCount: item.autocutParameters.partsCount,
              duration: item.autocutParameters.partsDurations,
            },
          },
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          response.data.cuts.forEach((cut) => {
            if (!cut.startSec && !cut.finishSec) {
              return;
            }
            item.addNewItemPart(cut.startSec, cut.finishSec);
          });
          if (!item.bitrateGraph) {
            item.bitrateGraph = response.data.bitrateGraph;
          }
        })
        .catch((erorr) => {
          console.error(erorr);
        });
    },
    selectItem(item) {
      if (this.isMixerStep) {
        return;
      }
      this.$store.commit("changeSelectItem", item);
    },
    isSelectedItem(item) {
      return this.previewItem === item;
    },
    checkAutocuttingIsReady() {
      let idsForCheck = this.items
        .filter(
          (i) =>
            !i.autocutParameters.isReadyToAutocut && i.loadingParameters.loaded
        )
        .map((i) => i.fileId);

      if (!idsForCheck.length) {
        return;
      }

      this.axios
        .post(
          "/v2.0/status/fileInfo",
          { mediaIds: idsForCheck },
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          response.data.forEach((element) => {
            let itemWithThisId = this.items.find(
              (i) => i.fileId === element.id
            );
            if (itemWithThisId) {
              itemWithThisId.autocutParameters.isReadyToAutocut =
                element.readyToAutoCut;
              itemWithThisId.autocutParameters.process = element.process;
            }
          });
        })
        .catch((erorr) => {
          console.error(erorr);
        });
    },
    convertSecondsToTimeboardStyle(time, isDropFloatPart) {
      return TimeHelper.convertSecondsToTimeboardStyle(time, isDropFloatPart);
    },
  },
});
